import {
    UNIT_CREATE_INFO_REQUEST,
    UNIT_CREATE_INFO_SUCCESS,
    UNIT_CREATE_INFO_ERROR,
} from 'state/actions/unit_create_info'

const initialState = {
    loading: false,
    loaded: false,
    errorMessage: '',
    sorties: {},
    fort_battles: {},
    expiresAt: null,
}

export default function wizardInfo(state = initialState, action = {}) {
    switch (action.type) {
    case UNIT_CREATE_INFO_REQUEST: {
        return {
            ...state,
            loading: true,
            loaded: false,
            errorMessage: '',
        }
    }
    case UNIT_CREATE_INFO_ERROR: {
        return {
            ...state,
            loading: false,
            loaded: false,
            errorMessage: action.payload.errorMessage,
        }
    }
    case UNIT_CREATE_INFO_SUCCESS: {
        return {
            ...state,
            loading: false,
            loaded: true,
            sorties: action.payload.sorties,
            fort_battles: action.payload.fort_battles,
            expiresAt: action.payload.expiresAt,
        }
    }
    default:
        return state
    }
}



// WEBPACK FOOTER //
// ./state/reducers/units/unit_create_info.js